import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { areIntervalsOverlapping } from "date-fns";
import { logOut } from "pages/auth/authSlice";
import { setCredentials } from "pages/auth/authSlice";
import { selectCsrfToken } from "pages/auth/csrfSlice";
import { API_CONFIG } from 'config/api';

// Base URL for APIs
const bUrl = API_CONFIG.v1BaseUrl;
// const bUrl = "https://api.pravdasolutionsinc.com/api/v1";
// const bUrl = "http://194.195.212.101/api/v1";


const baseQuery = fetchBaseQuery({
  baseUrl: bUrl,
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;

    if(token){
      headers.set("Authorization", `Bearer ${token}`);
    }

    const csrfToken = selectCsrfToken(getState());
    if (csrfToken) {
      headers.set('X-CSRFToken', csrfToken);
    }
    return headers;
  }
});

const baseQueryNoAuth = fetchBaseQuery({
  baseUrl: bUrl,
  credentials: 'include'
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if(result?.error?.status === 401 || result?.error?.status === 403){
    console.log('Attempting to refresh token');

    // Make a refresh request that signals we do NOT want the Authorization header
    const refreshResult = await baseQueryNoAuth(
      { 
        url: '/token/refresh/', 
        method: 'POST',
      },
      api,
      extraOptions
    );

    if (refreshResult?.data?.access){
      const username = api.getState().auth.username;

      // Store the new token
      api.dispatch(setCredentials({username, token: refreshResult.data.access }));

      // Retry the original query with new access token
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logOut());
    }
  }

  return result;

};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: builder => ({
    logoutUser: builder.mutation({
      query: () => ({ 
        url: 'logout/', 
        method: 'POST',
        credentials: 'include', 
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(logOut());
        } catch (error) {
          console.error('Failed to log out', error);
        }
      }
    }),
  })
});

export const { useLogoutUserMutation } = apiSlice;